import React, { Component } from 'react';
import NavItem from "./NavItem";

class Navigation extends Component{

	renderItem = (item) => {
		const {localizePath} = this.props;
		return (
			<NavItem
				key={'item-'+item.name.toLowerCase().replace(' ','-')}
				item={item}
				type={this.props.type}
				localizePath={localizePath}/>
		);
	};

	render(){
		const {navClassName, items} = this.props;
		return (
			<nav className={navClassName}>
				<ul>
					{items.map(this.renderItem)}
				</ul>
			</nav>
		);
	}
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/common/Navigation.js